import React from "react";

const NoBorderLayout = ({ children, noNavbar, noFooter }) => (
  <>
    {children}
  </>
);

export default NoBorderLayout;
